import { render } from "./AvatarCanvas.vue?vue&type=template&id=5a0ac34a&ts=true"
import script from "./AvatarCanvas.vue?vue&type=script&lang=ts"
export * from "./AvatarCanvas.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__